import { makeStyles } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import blue from '@material-ui/core/colors/blue';
import blueGrey from '@material-ui/core/colors/blueGrey';

const useStyles = makeStyles(theme => ({

    container: {
        // marginTop: theme.spacing(8),
        padding: theme.spacing(2),
        //  textAlign: 'center'
    },
    iconLeft: {
        marginRight: theme.spacing(1)
    },
    iconRight: {
        marginLeft: theme.spacing(1)
    },
    imgResponsive: {
        width: "100%"
    },
    progressKerja: {
        backgroundColor: green[500],
        padding: "1.25rem",
        color: "#fff"
    },
    wilayahKerja: {
        backgroundColor: red[500],
        padding: "1.25rem",
        color: "#fff"
    },
    floatRightIcon: {
        float: 'right'
    },
    blueGreyBackground: {
        backgroundColor: blueGrey[500],
        padding: "1.25rem",
        color: "#fff",
        textAlign: 'center',
        width: "100%"
    },

    fullWidth: {
        width: "100%"
    },
    textCenter: {
        textAlign: 'center'
    },
    textLeft: {
        textAlign: 'left'
    },
    textRight: {
        textAlign: 'right'
    },
    panel: {
        width: "100%"
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    form: {
        paddingBottom: theme.spacing(8)
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    btnWrap: {
        // width: '100%',
        position: 'relative',
        margin: '25px 0 40px',
    },
    buttonProgress: {
        color: theme.palette.secondary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    }

}))

export default useStyles;